<template>
  <div class="text-center">
    <img alt="Lihavapp logo small" class="logo-small" src="../assets/logo-small.svg" />
    <form class="form-login" @submit.prevent="login">
      <label for="username" class="sr-only">Username</label>
      <input
        type="text"
        id="username"
        name="username"
        class="form-control"
        placeholder="Username"
        v-model="username"
        required
        autofocus
      />
      <label for="password" class="sr-only">Password</label>
      <input
        type="password"
        id="password"
        name="password"
        class="form-control"
        placeholder="Password"
        v-model="password"
        required
      />

      <button class="btn btn-lg btn-primary btn-block" type="submit">Login</button>
    </form>
  </div>
</template>

<script>
import { store } from "@/store.js";

export default {
  name: "LoginView",
  data: function() {
    return {
      store: store,
      username: "",
      password: ""
    };
  },
  methods: {
    login: function(event) {
      let self = this;
      this.$auth.login({
        data: { username: this.username, password: this.password },
        success: function() {
          self.flashSuccess("Login successful");
        },
        error: function() {
          self.flashError("Login failed, please try again");
        }
      });
    }
  }
};
</script>

<style>
.form-login {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}
.form-login .checkbox {
  font-weight: 400;
}
.form-login .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-login .form-control:focus {
  z-index: 2;
}
.form-login input[type="text"] {
  margin-bottom: 10px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-login input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>